export function SaveUndoNotice({
  error,
  message,
  onDismiss,
  onUndo,
  undoing,
}: {
  readonly error: string | null;
  readonly message: string;
  readonly onDismiss: () => void;
  readonly onUndo: () => void;
  readonly undoing: boolean;
}) {
  return (
    <div className="save-undo-notice" role="status" aria-live="polite" aria-atomic="true">
      <strong>{message}</strong>
      {error ? <p role="alert">{error}</p> : null}
      <div className="inline-actions">
        <button
          type="button"
          className="secondary-action touch-target"
          disabled={undoing}
          onClick={onUndo}
        >
          {undoing ? 'Vracím poslední uložení…' : 'Vrátit poslední uložení'}
        </button>
        <button
          type="button"
          className="secondary-action touch-target"
          disabled={undoing}
          onClick={onDismiss}
        >
          Ponechat
        </button>
      </div>
    </div>
  );
}
